<div class="flex flex-col items-center justify-center h-[calc(100vh_-_100px)] bg-gray-100 text-gray-800">
    <h1 class="text-6xl font-bold text-red-600">403</h1>

    <p class="text-xl font-semibold mt-4">Forbidden</p>
    <p class="text-md text-gray-600 mt-2">You don't have permission to access this resource.</p>

    <a
        (click)="goHome()"
        (keydown)="goHome()"
        tabindex="0"
        class="mt-6 px-6 py-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg shadow-md transition duration-300 cursor-pointer"
    >
        Go Home
    </a>
</div>
